import { apiClient } from '../../../lib/api/client';

export interface SupportViewSessionResponse {
  accessToken: string;
  expiresInSeconds: number;
  tenantId: string;
  companyName: string;
}

export async function enterTenantSupportViewApi(
  tenantId: string
): Promise<SupportViewSessionResponse> {
  const response = await apiClient.post<SupportViewSessionResponse>(
    `/host/tenants/${tenantId}/enter-support-view`
  );
  return response.data;
}
